// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  Switch,
  TablePagination,
} from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Loading from '../../components/Loading';
import { useGetAllPaymentMethodMutation, useDeletePaymentMethodMutation } from '../../store/api/paymentApi';
import toast from 'react-hot-toast';
import { getPayment, getPaymentMethodTotalRecord, setPayment } from '../../store/state/paymentSlice';
import { checkPermissions } from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';

const TABLE_HEAD = [
  { id: ' avatarUrl', alignRight: false },
  { id: 'name', label: 'Title', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
];

export default function PaymentGetaway() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [paymentManagementData, setPaymentManagementData] = useState([]);
  const [getAllMethod, methodResponse] = useGetAllPaymentMethodMutation();
  const paymentData = useAppSelector(getPayment);
  console.log('paymentData', paymentData);
  const [findPaymentDetailById, deleteResponse] = useDeletePaymentMethodMutation();
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [vendorId, setVendorId] = useState<number>();
  const [open, setOpen] = useState(false);
  const filteredUsers = paymentManagementData;
  const isUserNotFound = filteredUsers.length === 0;
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const paymentMethodTotalRecord = useAppSelector(getPaymentMethodTotalRecord);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (paymentData) {
      setPaymentManagementData(paymentData);
    }
  }, [paymentData]);

  useEffect(() => {
    getAllMethod({
      token: token.token,
    });
  }, []);

  useEffect(() => {
    if (methodResponse.isSuccess) {
      dispatch(setPayment(methodResponse.data));
    }
    if (methodResponse.isError) {
      let errorData: any = methodResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [methodResponse.isSuccess, methodResponse.isError]);

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllMethod({
        token: token.token,
      });
    }
    if (deleteResponse.isError) {
      let errorData: any = deleteResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  const handleDelete = () => {
    setOpen(false);
    findPaymentDetailById({
      id: vendorId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllMethod({
      token: token.token,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllMethod({
      token: token.token,
    });
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Payment Method">
      {checkPermissions(PERMISSION.BLOG_ALL, token.permissions) ? (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
            <Typography variant="h4" gutterBottom>
              Payment Method
            </Typography>
            <Button
              style={{ color: 'white', backgroundColor: '#E23744' }}
              variant="contained"
              onClick={() => {
                navigate('/dashboard/add-Payment-method', { state: { editMode: false } });
              }}
              startIcon={<Iconify icon="eva:plus-fill" />}
              size="large"
            >
              Add
            </Button>
          </Stack>
          <Card>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={paymentData?.length}
                    numSelected={selected?.length}
                    onRequestSort={handleRequestSort}                
                  />
                  <TableBody>
                    {filteredUsers.length > 0 &&
                      filteredUsers.map((row) => {
                        const { id, name, description, fileUrl, isEnable } = row;
                        const isItemSelected = selected.indexOf(name) !== -1;

                        return (
                          <TableRow
                            hover
                            key={id.toString()}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell align="left">
                              <Avatar alt="Remy Sharp" src={fileUrl} />
                            </TableCell>
                            <TableCell
                              align="left"
                              onClick={() => {
                                navigate('/dashboard/add-Payment-method', { state: { editMode: true, editData: row } });
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <Typography fontWeight="normal" variant="subtitle2" color={'blue'}>
                                {name}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                {description}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center">
                                <Switch
                                  checked={isEnable}
                                  onClick={() => {
                                    setVendorId(id);
                                    handleOpen();
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            {/* <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={paymentMethodTotalRecord || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
          </Card>
          {open && (
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                  Are you sure?
                </Typography>
                <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                  <Button
                    variant="contained"
                    onClick={cancelDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    Yes
                  </Button>
                </Stack>
              </Box>
            </Modal>
          )}

          {methodResponse.isLoading ? <Loading /> : null}
        </Container>
      ) : null}
    </Page>
  );
}
